import { render, staticRenderFns } from "./DetalhesTimeLine.vue?vue&type=template&id=0bcda890&scoped=true"
import script from "./DetalhesTimeLine.vue?vue&type=script&lang=js"
export * from "./DetalhesTimeLine.vue?vue&type=script&lang=js"
import style0 from "./DetalhesTimeLine.vue?vue&type=style&index=0&id=0bcda890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcda890",
  null
  
)

export default component.exports